// extracted by mini-css-extract-plugin
module.exports = {"title__wrapper":"ArticleDetail_title__wrapper__1Sl-R","title":"ArticleDetail_title__2j_zr","subtitle":"ArticleDetail_subtitle__2Ohna"};